<template>
  <el-dialog title="wifi等级设置" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" :model="form">
      <el-form-item label="昵称" :label-width="formLabelWidth">
        <el-input v-model="form.nickname" autocomplete="off" disabled></el-input>
      </el-form-item>
      <el-form-item label="手机号" :label-width="formLabelWidth">
        <el-input v-model="form.mobile" autocomplete="off" disabled></el-input>
      </el-form-item>
      <el-form-item label="推荐人ID" :label-width="formLabelWidth">
        <el-input v-model="form.inviteId" autocomplete="off" disabled></el-input>
      </el-form-item>
      <el-form-item label="推荐人昵称" :label-width="formLabelWidth">
        <el-input v-model="form.inviteName" autocomplete="off" disabled></el-input>
      </el-form-item>
      <el-form-item label="wifi等级" :label-width="formLabelWidth">
        <el-select v-model="form.wifiGradeId" clearable placeholder="-请选择等级-">
          <el-option v-for="(item,index) in gradeList" :key="index" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="等级时效" :label-width="formLabelWidth">
        <el-select v-model="form.dateTypeWifi" clearable placeholder="-请选择等级-">
          <el-option v-for="(item,index) in wifiDateList" :key="index" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="editUser" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import WifiApi from '@/api/wifi.js';
  export default {
    data() {
      return {
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        loading: false,
        dialogVisible: false,
        wifiDateList: [{
          id: 1,
          name: '半年'
        }, {
          id: 2,
          name: '一年'
        }, {
          id: 3,
          name: '永久'
        }]
      }
    },
    props: ['open_edit', 'form', 'gradeList'],
    created() {

      this.dialogVisible = this.open_edit;

    },
    methods: {

      /*修改用户*/
      editUser() {
        let self = this;
        self.loading = true;
        let params = {
          userId: self.form.userId,
          wifiGradeId: self.form.wifiGradeId,
          dateTypeWifi: self.form.dateTypeWifi
        };
        WifiApi.changeUserGrade(params, true)
          .then(data => {
            self.loading = false;
            if (data.code == 1) {
              self.$message({
                message: '恭喜你，用户修改成功',
                type: 'success'
              });
              self.dialogFormVisible(true);
            }
          })
          .catch(error => {
            self.loading = false;
          });
      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        })
      }

    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/user/user/dialog/WifiGrade.vue